import { createApiSlice } from "@common";
import {
  
   CRUD_RECORD_STATUS
} from "@routes";

// Define the API config array
const apiConfig = [
  {
    name: "addRecordStatus",
    method: "post",
    url:  CRUD_RECORD_STATUS,
    stateKey: "message",
  },
  {
    name: "getRecordStatus",
    method: "get",
    url: CRUD_RECORD_STATUS,
    stateKey: "data",
  },
  {
    name: "updateRecordStatus",
    method: "put",
    url: CRUD_RECORD_STATUS,
    stateKey: "message",
  },
  {
    name: "deleteRecordStatus",
    method: "delete",
    url: CRUD_RECORD_STATUS,
    stateKey: "message",
  },
];

// Define custom reducers and their initial state
const customReducers = {
  initialState: {
    data: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {
    // Example of custom extra reducer
    someCustomAction: (state, action) => {
      // Custom reducer logic
    },
  },
};

// Generate the slice, thunks, and actions using the utility function
const { slice, thunks, actions } = createApiSlice(
  "recordStatus",
  apiConfig,
  customReducers,
);
const RecordStatusSlice = slice;
// Export the slice's reducer
export default RecordStatusSlice.reducer;

// Destructure and export thunks directly from thunksExports
export const {
  addRecordStatus,
  getRecordStatus,
  updateRecordStatus,
  deleteRecordStatus
} = thunks;

// Destructure and export actions directly from actionsExports
export const { rowSelect } =
  actions;
